module.exports = __webpack_public_path__ + "static/media/congrat_iphone.38c8fa43.png";